export const LabledAddress: { [key: string]: { Name: string; Logo?: string } } = {
    "GALYJFJ5SVD45FBWN2GT4IW67SEZ3IBOFSBSPUFCWV427NBNLG3PXEQU":{
        Name:"OKX",
        Logo:"/assets/okx.png",
    },
    "GDFNWH6ZFJVHJDLBMNOUT35X4EEKQVJAO3ZDL4NL7VQJLC4PJOQFWJ75":{
        Name:"Bitget",
        Logo:"/assets/bitget.png",
    },
    "GD5HGPHVL73EBDUD2Z4K2VDRLUBC4FFN7GOBLKPK6OPPXH6TED4TRK73":{
        Name:"MEXC",
        Logo:"/assets/mexc.png",
    },
    "GBC6NRTTQLRCABQHIR5J4R4YDJWFWRAO4ZRQIM2SVI5GSIZ2HZ42RINW":{
        Name:"Gate.io",
        Logo:"/assets/gate.png",
    },
    "GD24QVE4R42E4XRDF6T5IN6UAQLD2WN7OQGUC2FBHFUUZM7GLE4KG6YA":{
        Name:"Pionex",
        Logo:"/assets/pionex.png",
    },
    "GDL66HS4YTULXZ7NY7TZRUPCVD3BMANUIZUPCXU5HG46CVMI3YHBBWB6":{
        Name:"Pionex 2",
        Logo:"/assets/pionex.png",
    },
    //core team
    "GBQQRIQKS7XLMWTTRM2EPMTRLPUGQJDLEKCGNDIFGTBZG4GL5CHHJI25":{
        Name:"PI Foundation 1",
    },
    "GABT7EMPGNCQSZM22DIYC4FNKHUVJTXITUF6Y5HNIWPU4GA7BHT4GC5G":{
        Name:"PI Foundation 2",
    },
    "GALKEOXXIJKX76OMG5XNAIZA4F4Q5VRQBYW4LDU57SWORA7X47NSW4NM":{
        Name:"PI Foundation 3",
    },
    "GAODAYUBCUWKJIMGV6NWZ2BBM6ONSDEQY34ILE6OHJ2BRKUKFD2V55VT":{
        Name:"PI Foundation 4",
    },
    "GCR7QITP6BRU2RFAE5CODEAXLCC45FO3FFMDSVS4J662HVZLYXEAD22U":{
        Name:"PI Foundation 5",
    },
    "GC2BTJBNJCHWXDMFZRLAXDZ2BX7FJ27G2UPV5C2A6POON22ADADYCW22":{
        Name:"PI Foundation 6",
    },
    "GDJO44JV6MFWR66B25N5FSE5TLAYIUOTQQNGGQLHU4GWJITV5N3JMHAQ":{
        Name:"PI Foundation 7",
    },
    "GD77W2AC463MNMUSRHUJZHPTHD5XVI23J72NAHVFELNPNQI4CUZT5SVO":{
        Name:"PI Foundation 8",
    },
    "GAA32RYJ6Z2PNEVE7N2BYCGANKOIMKV346FEJLBYYJ6JE4ZT6K2BN4FK":{
        Name:"PI Foundation 9",
    },
    "GCWMRO6UH6EPGS2GBGHVUFWMCZ4UKZTK4QGPOFCOSFYNY5NMNQEZSPMR":{
        Name:"PI Foundation 10",
    },
    "GC5RNDCRO6DDM7NZDEMW3RIN5K6AHN6GMWSZ5SAH2TRJLVGQMB2I3BNJ":{
        Name:"PI Foundation 11",
    },
    "GB7HLN74IIY6PENSHHBBJJXWV6IZQDELTBZNXXORDGTL75O4KC5CUXEV":{
        Name:"PI Foundation 12",
    },
    "GBMZ7TIQWX56FI2URWSJEAIUWIRZ24AA3DWMJ42SC62CZ4FVQLU4VZD2":{
        Name:"PI Foundation 13",
    },
    "GDPDSLFVGEPX6FJKGZXSTJCPTSKKAI4KBHBAQCCKQDXISW3S5SJ6MGMS":{
        Name:"PI Foundation 14",
    },
}
export const coreTeamAddress = [
    "GBQQRIQKS7XLMWTTRM2EPMTRLPUGQJDLEKCGNDIFGTBZG4GL5CHHJI25",
    "GABT7EMPGNCQSZM22DIYC4FNKHUVJTXITUF6Y5HNIWPU4GA7BHT4GC5G",
    "GALKEOXXIJKX76OMG5XNAIZA4F4Q5VRQBYW4LDU57SWORA7X47NSW4NM",
    "GAODAYUBCUWKJIMGV6NWZ2BBM6ONSDEQY34ILE6OHJ2BRKUKFD2V55VT",
    "GC5RNDCRO6DDM7NZDEMW3RIN5K6AHN6GMWSZ5SAH2TRJLVGQMB2I3BNJ",
    "GB7HLN74IIY6PENSHHBBJJXWV6IZQDELTBZNXXORDGTL75O4KC5CUXEV",
    "GBMZ7TIQWX56FI2URWSJEAIUWIRZ24AA3DWMJ42SC62CZ4FVQLU4VZD2",
    "GDPDSLFVGEPX6FJKGZXSTJCPTSKKAI4KBHBAQCCKQDXISW3S5SJ6MGMS"
]